import { styled } from '@mui/material/styles';
import { Dialog, DialogTitle, DialogContent, DialogActions } from '@mui/material';
import { designTokens } from '../../tokens';

/**
 * Styled Dialog component
 */
export const StyledDialog = styled(Dialog)(() => ({
  '& .MuiDialog-paper': {
    borderRadius: designTokens.borderRadius.xl,
    boxShadow: designTokens.shadows['2xl'],
  },
}));

/**
 * Styled DialogTitle
 */
export const StyledDialogTitle = styled(DialogTitle)(() => ({
  fontFamily: designTokens.typography.fontFamily.primary,
  fontSize: designTokens.typography.fontSize.xl,
  fontWeight: designTokens.typography.fontWeight.semibold,
  color: designTokens.colors.neutral[900],
  padding: `${designTokens.spacing[4]} ${designTokens.spacing[4]} ${designTokens.spacing[2]}`,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',

  '& .MuiIconButton-root': {
    marginRight: -8,
  },
}));

/**
 * Styled DialogContent
 */
export const StyledDialogContent = styled(DialogContent)<{ dividers?: boolean }>(({ dividers }) => ({
  fontFamily: designTokens.typography.fontFamily.primary,
  fontSize: designTokens.typography.fontSize.sm,
  color: designTokens.colors.neutral[700],
  padding: designTokens.spacing[4],

  ...(dividers && {
    borderTop: `1px solid ${designTokens.colors.border.light}`,
    borderBottom: `1px solid ${designTokens.colors.border.light}`,
  }),
}));

/**
 * Styled DialogActions
 */
export const StyledDialogActions = styled(DialogActions)(() => ({
  padding: `${designTokens.spacing[3]} ${designTokens.spacing[4]}`,
  gap: designTokens.spacing[2],
}));

/**
 * Styled subtitle
 */
export const StyledSubtitle = styled('p')(() => ({
  margin: 0,
  marginTop: designTokens.spacing[1],
  fontSize: designTokens.typography.fontSize.sm,
  fontWeight: designTokens.typography.fontWeight.regular,
  color: designTokens.colors.neutral[600],
}));
